import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import styles from './RejectBillingAgreementDialog.styles.scss';
import cn from 'classnames';
import { Formik, Form } from 'formik';
import { rejectAgreementFormConfig } from './config/formConfig';
import { rejectAgreementValidationSchema } from './config/validation';
import { rejectAgreementInitialValues } from './config/initialValues';
import { FormikField } from '../../../../components/FormikField';
import i18n from '../../../../config/i18n';
import { useNavigate } from 'react-router';
import { AGREEMENT_TYPE } from '../../config/constants';

const getAgreementTypeLabel = (agreementType, t) => {
  return agreementType === AGREEMENT_TYPE.THIRD
    ? t('special_billing.third-party-billing-label', 'third-party')
    : t('special_billing.self-billing-label', 'self-billing');
};

const RejectBillingAgreementDialog = ({
  showDialog,
  setShowDialog,
  onConfirm,
  isAmendment,
  agreementType,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const typeLabel = getAgreementTypeLabel(agreementType, t);

  const [showSuccess, setShowSuccess] = useState(false);
  console.log(isAmendment);
  return (
    <Dialog
      onHide={() => setShowDialog(false)}
      className={cn(
        'rounded-4 overflow-hidden',
        styles.rejectBillingAgreementDialog,
      )}
      visible={!!showDialog}
    >
      <div className={styles.submissionMessage}>
        <span>
          <div>
            <i className="icn icn-cross-box" />
          </div>
        </span>
        {showSuccess && (
          <>
            <h3>{t('special_billing.agreement-rejected')}</h3>
            <p>
              {t(
                isAmendment
                  ? 'special_billing.amendment-rejected_desc'
                  : 'special_billing.agreement-rejected_desc',
                { type: typeLabel },
              )}
            </p>
            <div>
              <Divider className="my-4" />
              <div className={styles.formActions}>
                <Button
                  className={styles.formBtn}
                  label={t('common.home')}
                  onClick={() => {
                    setShowDialog(false);
                    navigate(
                      `/${i18n.language}/additional-functionalities/special-billing`,
                    );
                  }}
                />
              </div>
            </div>
          </>
        )}
        {!showSuccess && (
          <>
            <h3>{t('special_billing.reject-agreement')}</h3>
            <div>
              <Formik
                validateOnMount
                enableReinitialize
                validationSchema={rejectAgreementValidationSchema({
                  t,
                })}
                initialValues={rejectAgreementInitialValues()}
                onSubmit={(form) => {
                  onConfirm(form.reason).then(() => {
                    setShowSuccess(true);
                  });
                }}
              >
                {({ values, errors }) => {
                  return (
                    <Form className={styles.failureForm}>
                      {rejectAgreementFormConfig({
                        t,
                        typeLabel,
                        isAmendment,
                      }).map((section) => (
                        <div key={section.title}>
                          <h2>{section.title}</h2>
                          <div className={styles.formSection}>
                            {section.fields
                              .filter((item) => !item.hide)
                              .map((field) => (
                                <div
                                  key={field.name}
                                  className={styles.fieldWrapper}
                                >
                                  <label
                                    className={cn(
                                      field.required
                                        ? styles.requiredLabel
                                        : '',
                                      styles[field.labelClassName],
                                    )}
                                    htmlFor={field.name}
                                  >
                                    {field.label}
                                  </label>
                                  <FormikField
                                    name={field.name}
                                    component={field.component}
                                    error={errors[field.name]}
                                    controlProps={{ ...field.controlProps }}
                                    componentProps={{
                                      ...field.componentProps,
                                      className: cn(
                                        field.componentProps?.className,
                                        styles[field.componentProps?.className],
                                      ),
                                    }}
                                  />
                                </div>
                              ))}
                          </div>
                        </div>
                      ))}
                      <Divider className="my-4" />
                      <div className={styles.formActions}>
                        <Button
                          label={t('common.cancel')}
                          outlined
                          className={styles.formBtn}
                          type="button"
                          onClick={() => setShowDialog(false)}
                        />
                        <Button
                          type="submit"
                          className={styles.formBtn}
                          label={t('common.confirm')}
                          disabled={
                            Object.keys(errors).length > 0 && !values.terms
                          }
                        />
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </>
        )}
      </div>
    </Dialog>
  );
};

export default RejectBillingAgreementDialog;
